import { useState } from 'react';
import { Text } from 'react-native';
import EStyleSheet from 'react-native-extended-stylesheet';

import {
    Checkbox,
    Modal2,
    Page,
    React,
    Subtitle,
    Title,
    View
} from '../../../common';
import { storage } from '../../../services/localstorage';
import { COLORS } from '../../../styles/colors';

const BOOKING_CONTEXT_WARNING_POPUP_KEY = 'doNotShowBookingConsentPopup';
const USE_FOR_PROFILE = false;

export const setDoNotShowHistoryConsentWarning = async (value) => {
    try {
        if (USE_FOR_PROFILE) {
            await storage.setForProfile(BOOKING_CONTEXT_WARNING_POPUP_KEY, value);
        } else {
            await storage.set(BOOKING_CONTEXT_WARNING_POPUP_KEY, value);
        }
    } catch (e) {
        console.error(`Error set ${BOOKING_CONTEXT_WARNING_POPUP_KEY} in storage`, e);
    }
}

export const getDoNotShowHistoryConsentWarning = async () => {
    if (USE_FOR_PROFILE) {
        return await storage.getForProfile(BOOKING_CONTEXT_WARNING_POPUP_KEY, false);
    }
    return (await storage.get(BOOKING_CONTEXT_WARNING_POPUP_KEY, false)) == true;
}

export const ConsentConfirmationModal = ({
    onContinue,
    isSystemModal = false,
    /** Same UI without a second native Modal — required when showing on top of another modal on iOS. */
    embedded = false,
    /** Cancel / backdrop — only used when `embedded`. */
    onDismiss,
}) => {
    const [ doNotShow, setDoNotShow ] = useState(false);
    const closeNativeModal = isSystemModal ? Page.closeSystemModal : Page.closeModal;
    return <Modal2
        embedded={embedded}
        animationType="none"
        title={'titles.bookConsentConfiramtionTitle1'}
        buttonTitle={Object.R('buttons.confirm')}
        buttonCloseTitle={Object.R('button.cancelButton')}
        groupStyle={{borderTopWidth: 1, borderColor: COLORS.BORDER_GRAY}}
        // noScroll
        // hideClose
        onSubmit={() => {
            setDoNotShowHistoryConsentWarning(doNotShow);
            onContinue?.(doNotShow);
            if (!embedded) {
                closeNativeModal?.();
            }
        }}
        _onClose={() => {
            if (embedded) {
                onDismiss?.();
            } else {
                closeNativeModal?.();
            }
        }}
        submitButtonStyle={[]}
        // onRequestClose={() => {
        // }}
    >
        <View style={[ styles.container ]}>
            <Subtitle
                numberOfLines={0}
                style={[ styles.subtitle ]}>{Object.R('titles.bookConsentConfiramtionText1')}</Subtitle>
            <Title style={[ styles.title ]}>{Object.R('titles.bookConsentConfiramtionTitle2')}</Title>
            <View style={[ styles.tableItem ]}>
                <View style={[ styles.markItem ]}>
                    <Text style={[ styles.mark ]}>·</Text>
                </View>
                <View style={[ styles.subtitleItem ]}>
                    <Subtitle
                        numberOfLines={0}
                        style={[ styles.subtitle ]}>{Object.R('titles.bookConsentConfiramtionTableItem1')}</Subtitle>
                </View>
            </View>
            <View style={[ styles.tableItem ]}>
                <View style={[ styles.markItem ]}>
                    <Text style={[ styles.mark ]}>·</Text>
                </View>
                <View style={[ styles.subtitleItem ]}>
                    <Subtitle
                        numberOfLines={0}
                        style={[ styles.subtitle ]}>{Object.R('titles.bookConsentConfiramtionTableItem2')}</Subtitle>
                </View>
            </View>
            <View style={[ styles.tableItem ]}>
                <View style={[ styles.markItem ]}>
                    <Text style={[ styles.mark ]}>·</Text>
                </View>
                <View style={[ styles.subtitleItem ]}>
                    <Subtitle
                        numberOfLines={0}
                        style={[ styles.subtitle ]}>{Object.R('titles.bookConsentConfiramtionTableItem3')}</Subtitle>
                </View>
            </View>
            <View style={[ styles.footer ]}>
                <View style={[ styles.line ]}/>
                <View>
                    <Subtitle
                        numberOfLines={0}
                        style={[ styles.subtitle, { paddingBottom: 12 } ]}>{Object.R('titles.bookConsentConfiramtionFooter')}</Subtitle>
                </View>
                <View style={{ marginBottom: 12 }}>
                    <Checkbox
                        title={Object.R('titles.bookConsentConfiramtionCheckbox')}
                        textStyle={[ styles.subtitle, { marginTop: -2, marginLeft: 6 } ]}
                        selected={doNotShow}
                        onPress={(...param) => {
                            setDoNotShow(p => !p);
                            console.log('Set checkbox params', param);
                        }}
                    />
                </View>
            </View>
        </View>
    </Modal2>;
};

const borderWidth = 0;
const styles = EStyleSheet.create({
    container: {
        borderWidth,
        padding: 8,
        marginHorizontal: 24,
        flex: 1,
    },
    main: {
        flexGrow: 1,
    },
    footer: {},
    title: {
        fontWeight: '600',
        fontSize: 14,
        lineHeight: 22,
        fontFamily: '$sourceSansPropFontFamily_bold',
        paddingVertical: 10,
    },
    subtitle: {
        fontWeight: '400',
        flexWrap: 'wrap',
        lineHeight: 22,
        fontSize: 14,
        fontFamily: '$sourceSansPropFontFamily',
    },
    mark: {
        fontWeight: '600',
    },
    tableItem: {
        flexDirection: 'row',
        alignItems: 'flex-start',
    },
    markItem: {
        paddingHorizontal: 8,
        // borderWidth,
    },
    subtitleItem: {
        // borderWidth,
        flex: 1,
    },
    line: {
        borderColor: COLORS.BORDER_GRAY,
        borderWidth: .5,
        marginVertical: 16,
        height: 1,
    },
});
